import cookieHelper from 'js-cookie';
import consoleHelper from '@util/consoleHelper';
import moment from 'moment';

/**
 * @module  shixunApp/sessionManager
 */

const manager = {

    /**
     * @member  authorization
     * @type    {String}
     */
    authorization : '',

    /**
     * @member  expireTime
     * @type    {Number}
     */
    expireTime : 0,

    init : function () {

        this.authorization = localStorage.getItem('Authorization')
            || cookieHelper.get('Authorization')
            || '';

        this.expireTime = parseFloat(localStorage.getItem('AuthorizationExpireTime')
            || cookieHelper.get('AuthorizationExpireTime')
            || '');
    },

    /**
     * @method  getAuthorization
     * @return {String|null}
     */
    getAuthorization : function () {

        let msg = '[sessionManager] get authorization...';

        if (!this.authorization)
        {
            msg += '  authorization not defined.'
            consoleHelper.logDebug(msg);
            return null;
        }

        msg += '  authorization:' + this.authorization;
        consoleHelper.logDebug(msg);
        consoleHelper.logDebug('[sessionManager] expire time:' + moment(this.expireTime).format('YYYY-MM-DD HH:mm:ss'));
        if (this.expireTime && new Date().getTime() > this.expireTime)
        {
            return null;
        }

        return this.authorization;
    },

    /**
     * @method  setAuthorization
     * @param   {String}  Authorization
     */
    setAuthorization : function (Authorization) {
        localStorage.Authorization = Authorization;
        cookieHelper.set('Authorization', Authorization);
    },

    /**
     * @method  removeAuthorization
     */
    removeAuthorization : function () {
        localStorage.removeItem('Authorization');
        cookieHelper.remove('Authorization');
    },

    /**
     * @method  updateSession
     * @param   {Object}  options
     * @param   {String}  options.Authorization
     * @param   {String}  options.authTokenTime
     */
    updateSession : function (options = {}) {

        this.removeSession();

        const Authorization = options.Authorization || '';
        const authTokenTime = options.authTokenTime || '';

        // update current session
        this.authorization = Authorization;
        this.authTokenTime = new Date().getTime() + authTokenTime * 1000;

        // save data to browser and http cookie
        localStorage.setItem('Authorization', Authorization);
        cookieHelper.set('Authorization', Authorization);
        localStorage.setItem('AuthorizationExpireTime', this.authTokenTime);
        cookieHelper.set('AuthorizationExpireTime', this.authTokenTime);
    },

    /**
     * @method  removeSession
     */
    removeSession : function () {
        this.authorization = '';
        this.authTokenTime = 0;
        localStorage.removeItem('Authorization');
        localStorage.removeItem('AuthorizationExpireTime');
        cookieHelper.remove('Authorization');
        cookieHelper.remove('AuthorizationExpireTime');
    }

};

manager.init();

export default manager;

